import React from "react";
import DialogSearch from "../DialogSearch";
import TileQueue from "../../Tile/TileQueue";
import PropTypes from "prop-types";
import Queue from "../../../Utility/Crud/Queue";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchQueue extends DialogSearch {

    static contextType = MainContext; // For legacy class components

    /**
     * Searches for dpartments by several name combinations or ID.
     *
     * @param {string} query The search query.
     * @returns A list of filtered queue.
     */
    getSearchResults(query) {
        return Queue.search(this.state.data, query, true);
    }

    /**
     * Gets the data that should be used in this dialog. Data can be manually
     * passed via the data prop, otherwise it falls back to the global list.
     *
     * @returns {array}
     */
    getData() {
        if (this.props.data) {
            return this.props.data;
        } else {
            return Object.values(this.context.queuesIndexed);
        }
    }

    /**
     * @param {object} queue The queue object.
     * @returns A TileQueue component for this queue.
     */
    renderTile(queue) {
        return (
            <TileQueue
                key={ queue.id }
                queue={ queue }
            />
        );
    }
}
